export function formatDate(date) {
    date = new Date(date)
    return (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear()
}

export const setFormValueById = function (id, value) {
    const element = window.document.getElementById(id)
    let lastValue = element.value;
    element.value = value;
    let event = new Event("input", { target: element, bubbles: true });
    // React 15
    event.simulated = true;
    // React 16
    let tracker = element._valueTracker;
    if (tracker) {
        tracker.setValue(lastValue);
    }
    element.dispatchEvent(event);
}

export const setFormValueByElement = function (element, value) {
    let lastValue = element.value;
    element.value = value;
    let event = new Event('input', { target: element, bubbles: true });
    // React 15
    event.simulated = true;
    // React 16
    let tracker = element._valueTracker;
    if (tracker) {
        tracker.setValue(lastValue);
    }
    element.dispatchEvent(event);
}


export const unsecuredCopyToClipboard = function (text) {
    const textArea = document.createElement("textarea");
    document.body.appendChild(textArea);
    textArea.value = text;
    textArea.focus();
    textArea.select();
    try {
        document.execCommand('copy');
        console.log('Copy')
    } catch (err) {
        console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
}

export const fullHeightModalResize = (spacing = 20) => {
    let fields = document.querySelectorAll('.dialogContentFullHeight .dialogFieldFullHeight')
    fields.forEach(function (item) {
        let parent = item.closest('.dialogContentFullHeight');
        let fullHeightOffset = item.getAttribute('fullheightoffset') || 0
        let maxHeight = parent.offsetHeight - item.offsetTop + parent.offsetTop - spacing - fullHeightOffset
        if (window.innerWidth < 768) {
            item.style.maxHeight = maxHeight + 'px'
        } else {
            item.style.maxHeight = 'auto'
        }
    })
}